import script from "./DigitalProductPrice.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductPrice.vue?vue&type=script&lang=js"
export * from "./DigitalProductPrice.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/digital-product-card/DigitalProductPrice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42e460a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42e460a3', __exports__)) {
    api.reload('42e460a3', __exports__)
  }
  
}


export default __exports__